export enum DeviceType {
  LIGHT = 1,
  /**
   * TBD: this is currently poorly documented.
   */
  UNKOWN_LIGHT = 2,
  DIMMER_LIGHT = 3,
  SHUTTER = 6,
  FAN = 9
}

export interface DeviceRoom {
  id: string;
  name: string;
}

export interface DeviceApartment {
  id: string;
  name: string;
  code: string;
}

export interface DeviceBuilding {
  id: string;
  name: string;
}

export interface DeviceWiserOpts {
  getLightAddress?: string;
  setLightAddress?: string;

  getDimmerAddress?: string;
  setDimmerAddress?: string;

  getStatusAddress?: string;
  /**
   * Used to set the Shutter status (0, 1).
   *
   * @type {string}
   * @memberof DeviceWiserOpts
   */
  setStatusAddress?: string;

  getMoveAddress?: string;
  /**
   * Used to set the Shutter direction (up, down).
   *
   * @type {string}
   * @memberof DeviceWiserOpts
   */
  setMoveAddress?: string;

  setFanAddress?: string;
  
  setTemperatureAddressSummer?: string;
  setTemperatureAddressWinter?: string;
}

export interface Device {
  id?: string;
  name: string;
  type: DeviceType;
  categoryName: string;
  room?: DeviceRoom;
  apartment?: DeviceApartment;
  building: DeviceBuilding;
  wiserOpts?: DeviceWiserOpts;

  // Below props are only used by the client.
  lightValue?: boolean;
  dimmerLightValue?: number;
  shutterDirectionValue?: string;
  shutterStatusValue?: string;
  shutterEffectiveStatus?: string;
}
